var exports = {
  "bL": "Root__AFCz6h",
  "y9": "FooterRedesignOffset__7WTq5y",
  "Wu": "PageLayoutRoot__DQmNnv",
  "Y9": "Header__JkmET9",
  "Bx": "Sidebar__WfB1v5",
  "x2": "SidebarTrigger__DTaRTA",
  "wN": "HeaderInner__vi8Fya",
  "R4": "DialogBody__Vg5c6j",
  "Es": "DialogFooter__nat4jx",
};

module.exports = exports;
